import React from 'react'

import Label from '@/v2/components/common/FieldLabel'
import SelectInputField from '@/v2/components/common/SelectInputField'
import FormControl from '@mui/material/FormControl'
import Tooltip from '@mui/material/Tooltip'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import Box from '@mui/material/Box'

const ContractField = ({ register, contracts, errors, ...props }) => {
  return (
    <FormControl variant="standard">
      <Label variant="h4" bold color="grey.darkgrey" mb={5}>
        Apply to a contract?
      </Label>

      <Box display="flex" alignItems="center" gap={0.5} mb={0.5}>
        <Tooltip
          title="Only active contracts without existing payment plans are listed"
          arrow
          placement="right"
        >
          <InfoOutlinedIcon
            sx={{ fontSize: '16px', color: 'grey.main', cursor: 'help' }}
          />
        </Tooltip>
        <Label variant="body1" color="grey.darkgrey" sx={{ fontSize: '13px' }}>
          Contract
        </Label>
      </Box>

      <SelectInputField
        fullWidth
        {...props}
        placeholder="Select a contract"
        options={contracts
          .filter(contract => !contract?.paymentPlan)
          .map(contract => ({
            label: `${contract.identifierToken} - ${contract.patientLegalName}`,
            value: contract.id,
          }))}
        error={errors?.contractId?.message}
        {...register('contractId', {
          setValueAs: value =>
            value === '' || value === null ? null : parseInt(value, 10),
        })}
      />
    </FormControl>
  )
}

export default ContractField
